(function () {
  if (window.__glamyeBundleChooseBound) return;
  window.__glamyeBundleChooseBound = true;

  var cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var active = null;

  function popupEls(popup) {
    return {
      img: popup.querySelector('[data-ps-img]'),
      title: popup.querySelector('[data-ps-title]'),
      opts: popup.querySelector('[data-ps-opts]'),
      go: popup.querySelector('[data-ps-go]'),
      goText: popup.querySelector('[data-ps-go-text]'),
      price: popup.querySelector('[data-ps-price]'),
      cmp: popup.querySelector('[data-ps-cmp]'),
      save: popup.querySelector('[data-ps-save]'),
      inc: popup.querySelector('[data-ps-inc]'),
      close: popup.querySelector('[data-ps-close]')
    };
  }

  function setGoLabel(els, text) {
    if (els.goText) els.goText.textContent = text;
    else if (els.go) els.go.textContent = text;
  }

  function closePopup(popup) {
    if (!popup) return;
    popup.classList.remove('is-open');
    popup.hidden = true;
    document.body.style.overflow = '';
    active = null;
  }

  function checkoutVariant(variant, els, label) {
    if (!variant || !variant.av) return;
    if (els.go) {
      els.go.disabled = true;
      els.go.classList.add('is-busy');
      setGoLabel(els, 'Adding...');
    }
    fetch(cartRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error();
        window.location.href = cartRoot + 'checkout';
      })
      .catch(function () {
        if (!els.go) return;
        els.go.disabled = false;
        els.go.classList.remove('is-busy');
        setGoLabel(els, label || 'Checkout');
      });
  }

  function parseVariants(card) {
    var dataEl = card.querySelector('[data-variants]');
    if (!dataEl) return [];
    try {
      return JSON.parse(dataEl.textContent);
    } catch (e) {
      return [];
    }
  }

  function currentSelection(card, variants) {
    var sel = variants[0] && variants[0].o ? variants[0].o.slice() : [];
    card.querySelectorAll('[data-opt]').forEach(function (group) {
      var activePill = group.querySelector('.is-active');
      if (activePill) sel[+group.dataset.opt] = activePill.dataset.val;
    });
    return sel;
  }

  function findVariant(variants, sel) {
    return variants.find(function (v) {
      return v.o.join('|') === sel.join('|');
    }) || variants[0];
  }

  function openPopup(card) {
    var root = card.closest('[data-bundle-choose-root]') || document;
    var popup = root.querySelector('[data-ps-popup]');
    if (!popup) return;

    var variants = parseVariants(card);
    if (!variants.length) return;

    var hasOpts = !!card.querySelector('.ps-variants') || !!card.querySelector('[data-bundle-desc]');
    var sel = currentSelection(card, variants);
    var current = findVariant(variants, sel);

    if (!hasOpts) {
      checkoutVariant(current, {}, 'Buy Now');
      return;
    }

    var els = popupEls(popup);
    var title = card.dataset.title || '';
    var curSel = sel.slice();
    var popupCur = current;

    function paint() {
      popupCur = findVariant(variants, curSel);
      var ok = popupCur && popupCur.av;
      if (popupCur) {
        if (popupCur.i && els.img) {
          els.img.src = popupCur.i;
          els.img.alt = title;
          els.img.hidden = false;
        } else if (els.img) {
          els.img.hidden = true;
        }
        if (els.price) els.price.textContent = popupCur.p || '';
        if (els.cmp) {
          els.cmp.textContent = popupCur.c || '';
          els.cmp.hidden = !popupCur.c;
        }
        if (els.save) {
          var saveOn = Number(popupCur.s) > 0;
          els.save.textContent = saveOn ? 'Save 20%' : '';
          els.save.hidden = !saveOn;
        }
      }
      if (els.go) els.go.disabled = !ok;
      setGoLabel(els, ok ? 'Checkout · ' + (popupCur && popupCur.p ? popupCur.p : '') : 'Sold Out');
    }

    if (els.title) els.title.textContent = title;
    if (els.inc) {
      var desc = card.querySelector('[data-bundle-desc]');
      els.inc.innerHTML = desc ? desc.innerHTML : '';
      els.inc.hidden = !desc;
      els.inc.querySelectorAll('.metafield-multi_line_text_field').forEach(function (el) {
        var parts = el.innerHTML.split(/<br\s*\/?>/i);
        if (parts.length < 2 || el.querySelector('strong')) return;
        el.innerHTML = '<strong>' + parts[0].trim() + '</strong><br>' + parts.slice(1).join('<br>').trim();
      });
    }
    if (els.opts) {
      els.opts.innerHTML = '';
      var src = card.querySelector('.ps-variants');
      if (src) {
        var clone = src.cloneNode(true);
        clone.querySelectorAll('.ps-pill').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var group = btn.parentNode;
            var oi = +group.dataset.opt;
            group.querySelectorAll('.ps-pill').forEach(function (x) {
              x.classList.remove('is-active');
            });
            btn.classList.add('is-active');
            curSel[oi] = btn.dataset.val;
            var nameEl = group.previousElementSibling && group.previousElementSibling.querySelector('[data-selname]');
            if (nameEl) nameEl.textContent = btn.dataset.val;
            paint();
          });
        });
        els.opts.appendChild(clone);
      }
    }

    paint();
    popup.hidden = false;
    popup.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    active = { popup: popup, els: els, getCurrent: function () { return popupCur; } };
  }

  document.addEventListener('click', function (e) {
    var closeBtn = e.target.closest('[data-ps-close]');
    if (closeBtn) {
      var popup = closeBtn.closest('[data-ps-popup]');
      if (popup) closePopup(popup);
      return;
    }

    if (e.target.classList && e.target.classList.contains('gbp-popup')) {
      closePopup(e.target);
      return;
    }

    var goBtn = e.target.closest('[data-ps-go]');
    if (goBtn && active && active.popup && active.popup.contains(goBtn)) {
      checkoutVariant(active.getCurrent(), active.els, 'Checkout');
      return;
    }

    var trigger = e.target.closest('[data-bundle-choose]');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    var card = trigger.closest('[data-product]');
    if (card) openPopup(card);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && active && active.popup) closePopup(active.popup);
  });
})();
